import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetPrepaidCardTransactionsParams, GetUserPrepaidCardParams } from '@models/prepaidCard';

const userPrepaidCardQueries = createQueryKeys('userPrepaidCard', {
  list: () => ({
    queryKey: ['list'],
    queryFn: () => UserPrepaidCardApi.getUserPrepaidCards(),
  }),
  detail: (id: string) => ({
    queryKey: ['detail', id],
    queryFn: () => UserPrepaidCardApi.getUserPrepaidCard(id),
  }),
  favoriteList: (userId: string) => ({
    queryKey: ['userPrepaidCardFavorite', userId],
    queryFn: () => UserPrepaidCardApi.getFavoritePrepaidCards(),
  }),
  transactions: (id: string, params: GetPrepaidCardTransactionsParams) => ({
    queryKey: [id, params],
    queryFn: () => UserPrepaidCardApi.getPrepaidCardTransactions(id, params),
  }),
});

export default userPrepaidCardQueries;
